<form [formGroup]="coordinateSystemForm">
  <div class="coordinate-system-form-row">
    <mat-form-field>
      <mat-select
        formControlName="Type"
        placeholder="{{ 'configurations-fields.tooltips.ProjectionType' | translate | titlecase }}"
        (selectionChange)="onCoordinateSystemTypeChange($event)"
      >
        <mat-option *ngFor="let type of coordinateSystemTypes" [value]="type">
          {{ getCoordinateSystemLabel(type) }}
        </mat-option>

        <mat-option *ngFor="let coordinateSystem of customCoordinateSystems" [value]="coordinateSystem">
          {{ coordinateSystem.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="coordinate-system-form-row uom-row with-hint" *ngIf="isCoordinateSystemEpsgDisplay">
    <mat-form-field>
      <input
        class="coordinate-system-epsg"
        formControlName="CoordinateSystemEpsg"
        matInput
        type="number"
        min="1"
        placeholder="{{ 'configurations-fields.CoordinateSystem' | translate }}"
      />

      <mat-icon matSuffix color="primary" (click)="openEpsgHintDialog($event)">help_outline</mat-icon>
    </mat-form-field>

    <mat-form-field>
      <mat-select placeholder="Uom" formControlName="MeasurementSystem">
        <mat-option *ngFor="let measurementSystemOption of measurementSystemList"
                    [value]="measurementSystemOption.value">
          {{ measurementSystemOption.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="coordinate-system-form-row manual-coordinates" *ngIf="isManualCoordinatesDisplay">
    <div class="first-row">
      <mat-form-field>
        <input
          matInput
          type="number"
          placeholder="{{ 'configurations-fields.Altitude' | translate }}"
          formControlName="Altitude"
        />
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          type="number"
          placeholder="{{ 'configurations-fields.Latitude' | translate }}"
          formControlName="Latitude"
        />
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          type="number"
          placeholder="{{ 'configurations-fields.Longitude' | translate }}"
          formControlName="Longitude"
        />
      </mat-form-field>

    </div>
    <div class="second-row">
      <mat-form-field>
        <input
          matInput
          type="number"
          placeholder="{{ 'configurations-fields.Pitch' | translate }}"
          formControlName="Pitch"
          name="Pitch"
        />
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          type="number"
          placeholder="{{ 'configurations-fields.Roll' | translate }}"
          formControlName="Roll"
          name="Roll"
        />
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          type="number"
          placeholder="{{ 'configurations-fields.Yaw' | translate }}"
          formControlName="Yaw"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="coordinate-system-form-row uom-row" *ngIf="isVerticalDatumDisplay">
    <mee-vertical-datum [espg]="espg" formControlName="VerticalDatum"></mee-vertical-datum>

    <mat-form-field>
      <mat-select placeholder="Uom" formControlName="VerticalMeasurementSystem">
        <mat-option *ngFor="let measurementSystemOption of measurementSystemList"
                    [value]="measurementSystemOption.value">
          {{ measurementSystemOption.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
